window.max_colleague = 0;
class AddFields {
    constructor() {
        this.links = document.querySelectorAll('.add_fields');
        this.iterateLinks();
    }

    iterateLinks() {
        if (this.links.length === 0) return
        this.links.forEach(link => {
            link.addEventListener('click', e => {
                this.handleClick(link, e)
            });
        });
    }

    handleClick(link, e) {
        if (!link || !e) return;
        e.preventDefault();

        if (max_colleague === 5) {
            alert(`Colleague limit reached. The maximum number of colleagues you can bring is 5`)
            e.preventDefault();
        } else {
            let time = new Date().getTime();
            let linkId = link.dataset.id;
            let regexp = linkId ? new RegExp(linkId, 'g') : null
            let newFields = regexp ? link.dataset.fields.replace(regexp, time) : null
            
            newFields ? link.insertAdjacentHTML('beforebegin', newFields) : null
            max_colleague += 1;

        }
    }

}

window.addEventListener('turbolinks:load', () => new AddFields());